<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Typography from "$lib/components/Typography/Typography.svelte";
  export let quantity: number = 0;
  export let totalInventory = NaN;
  export let disabled = false;

  const dispatch = createEventDispatcher();
  const onChange = (num: number) => dispatch("change", num);
  $: onChange(quantity);
  $: if (quantity && quantity > totalInventory) {
    quantity = totalInventory;
  }
</script>

<style lang="scss">
  .quantity {
    align-items: center;
    display: flex;
    &--button {
      align-items: center;
      border: none;
      display: flex;
      height: 30px;
      justify-content: center;
      width: 34px;
      background-color: $on-surface-5;
      transition: background-color 0.125s ease;

      &:disabled {
        opacity: 50%;
        cursor: not-allowed;
        &:hover {
          background-color: $on-surface-10;
        }
      }

      &:first-child {
        border-right: 1px solid $on-surface-10;
        border-bottom-left-radius: 2px;
        border-top-left-radius: 2px;
      }
      &:last-child {
        border-left: 1px solid $on-surface-10;
        border-bottom-right-radius: 2px;
        border-top-right-radius: 2px;
      }
      &:hover {
        background-color: $on-surface-10;
      }
    }
    &--value {
      align-items: center;
      border: none;
      display: flex;
      height: 30px;
      justify-content: center;
      min-width: 34px;
      background-color: $on-surface-5;
    }
  }
</style>

<div class="quantity">
  <button
    class="quantity--button"
    on:click={() => (quantity > 0 ? (quantity -= 1) : 0)}
    {disabled}
  >
    <svg
      width="14"
      height="2"
      viewBox="0 0 14 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 2H0V0H14V2Z" fill="var(--on-surface)" />
    </svg>
  </button>
  <div class="quantity--value">
    <Typography component="span" variant="body1">
      {quantity}
    </Typography>
  </div>
  <button
    class="quantity--button"
    on:click={() => (quantity += 1)}
    disabled={(quantity && quantity >= totalInventory) || disabled}
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="var(--on-surface)" />
    </svg>
  </button>
</div>
